module.exports = __webpack_public_path__ + "img/img_throw_5@3x.6fc38366.png";